// eslint-disable-next-line no-unused-vars
(function () {
  var ITEM_OPEN_CLASS = 'accordion-item-open';
  var TOGGLE_OPEN_CLASS = 'is-open';
  var ARROW_OPEN_CLASS = 'is-open';
  var CONTENT_TRANSITION = 'height 0.4s ease, opacity 0.3s ease, margin-top 0.3s ease';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function getSectionParts(section) {
    var toggle = section.querySelector('.accordion-toggle');
    var content = section.querySelector('.accordion-content');
    var arrow = toggle ? toggle.querySelector('img[id^="arrow-"]') : null;
    return { toggle: toggle, content: content, arrow: arrow };
  }

  function clearTransition(content) {
    if (content._accordionTransitionHandler) {
      content.removeEventListener('transitionend', content._accordionTransitionHandler);
      content._accordionTransitionHandler = null;
    }
  }

  function closeSection(section, options) {
    var parts = getSectionParts(section);
    if (!parts.toggle || !parts.content) return;

    var content = parts.content;
    var skipAnimation = options && options.skipAnimation;

    clearTransition(content);

    var currentHeight = content.getBoundingClientRect().height;

    section.classList.remove(ITEM_OPEN_CLASS);
    parts.toggle.classList.remove(TOGGLE_OPEN_CLASS);
    parts.toggle.setAttribute('aria-expanded', 'false');
    if (parts.arrow) parts.arrow.classList.remove(ARROW_OPEN_CLASS);

    content.setAttribute('aria-hidden', 'true');

    if (skipAnimation || currentHeight === 0) {
      content.style.transition = '';
      content.style.height = '';
      content.style.marginTop = '';
      content.style.opacity = '';
      content.style.display = 'none';
      return;
    }

    content.style.display = 'block';
    content.style.transition = 'none';
    content.style.height = currentHeight + 'px';
    content.style.marginTop = '1rem';
    content.style.opacity = '1';
    content.offsetHeight; // force reflow

    content.style.transition = CONTENT_TRANSITION;
    requestAnimationFrame(function () {
      content.style.height = '0px';
      content.style.marginTop = '0px';
      content.style.opacity = '0';
    });

    var handler = function (event) {
      if (event.target !== content || event.propertyName !== 'height') return;
      clearTransition(content);
      content.style.transition = '';
      content.style.height = '';
      content.style.marginTop = '';
      content.style.opacity = '';
      content.style.display = 'none';
    };

    content._accordionTransitionHandler = handler;
    content.addEventListener('transitionend', handler);
  }

  function openSection(section, options) {
    var parts = getSectionParts(section);
    if (!parts.toggle || !parts.content) return;

    var content = parts.content;
    var skipAnimation = options && options.skipAnimation;

    clearTransition(content);

    section.classList.add(ITEM_OPEN_CLASS);
    parts.toggle.classList.add(TOGGLE_OPEN_CLASS);
    parts.toggle.setAttribute('aria-expanded', 'true');
    if (parts.arrow) parts.arrow.classList.add(ARROW_OPEN_CLASS);

    content.setAttribute('aria-hidden', 'false');
    content.style.display = 'block';

    var targetHeight = content.scrollHeight;

    if (skipAnimation) {
      content.style.transition = '';
      content.style.height = '';
      content.style.marginTop = '';
      content.style.opacity = '';
      return;
    }

    if (targetHeight === 0) {
      content.style.transition = '';
      content.style.height = '';
      content.style.marginTop = '';
      content.style.opacity = '';
      return;
    }

    content.style.transition = 'none';
    content.style.height = '0px';
    content.style.marginTop = '0px';
    content.style.opacity = '0';
    content.offsetHeight; // force reflow

    content.style.transition = CONTENT_TRANSITION;
    requestAnimationFrame(function () {
      content.style.height = targetHeight + 'px';
      content.style.marginTop = '1rem';
      content.style.opacity = '1';
    });

    var handler = function (event) {
      if (event.target !== content || event.propertyName !== 'height') return;
      clearTransition(content);
      content.style.transition = '';
      content.style.height = '';
      content.style.marginTop = '';
      content.style.opacity = '';
    };

    content._accordionTransitionHandler = handler;
    content.addEventListener('transitionend', handler);
  }

  function initAccordion(root) {
    if (!root || root.dataset.kursAccordionInit === 'true') return;
    root.dataset.kursAccordionInit = 'true';

    var sections = toArray(root.children).filter(function (child) {
      return child && child.nodeType === 1;
    });

    sections.forEach(function (section) {
      var parts = getSectionParts(section);
      if (!parts.toggle || !parts.content) return;

      // Ensure consistent collapsed state before binding
      closeSection(section, { skipAnimation: true });

      parts.toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var isOpen = section.classList.contains(ITEM_OPEN_CLASS);

        if (isOpen) {
          closeSection(section);
          return;
        }

        sections.forEach(function (other) {
          if (other !== section) closeSection(other);
        });

        openSection(section);
      });
    });

    var defaultSection = sections[0];
    if (defaultSection) openSection(defaultSection, { skipAnimation: true });
  }

  function initializeAllAccordions(context) {
    var root = context || document;

    if (root.classList && root.classList.contains('kurs-accordion')) {
      initAccordion(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      toArray(root.querySelectorAll('.kurs-accordion')).forEach(initAccordion);
    }
  }

  ready(function () {
    initializeAllAccordions();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllAccordions(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initializeAllAccordions(event.target);
  });
})();
